import React from "react";
import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function WesternVistasHero() {
  return <section id="western-vistas-hero" className="dark bg-background text-foreground relative h-screen min-h-[600px] w-full overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562326/img/image_ocr5kjh4.png" className="h-full w-full object-cover" alt="Rugged western landscape at dusk" />
        {}
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent opacity-80" />
      </div>

      {}
      <div className="relative z-10 container mx-auto flex flex-col items-center text-center ![padding:0px_16px_0px_16px] !h-[290px]">
        {}
        <h1 className="font-serif text-white text-[15vw] leading-[0.85] tracking-wide uppercase drop-shadow-2xl select-none !text-5xl md:text-[8vw]">WILDLINGS WEST OVERLAND</h1>

        {}
        <div className="mt-6 md:mt-8 flex items-center gap-3 font-mono text-chart-2 text-sm md:text-lg tracking-[0.2em] uppercase bg-black/40 backdrop-blur-md px-6 py-3 rounded-sm border border-white/10 shadow-lg">
          <MapPin className="w-4 h-4 text-primary" />
          <span>Coordinates: 38.5733° N, 109.5498° W</span>
        </div>

        {}
        <div className="mt-12 md:mt-16">
          <Link to="/TravelLogPage">
            <div className="relative group inline-block">
              {}
              <div className="absolute -inset-1 rounded-sm bg-primary/30 blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute -inset-[2px] rounded-sm border border-primary/60 opacity-50 animate-pulse" />
              
              
            </div>
          </Link>
        </div>
      </div>
    </section>;
}